import { json5Parse } from '@rehaje/mustache'
import { clone } from '@rehaje/shared'

import type { AnyExpressionSpecific } from './TypedNode'

const constantMap = new Map<string, any>()
const MAX_CACHE_SIZE = 10_000

export const createTypedNode: RehajeMiddlewares['createTypedNode'] = (
  ctx,
  next
) => {
  try {
    const payload = ctx?.payload as AnyExpressionSpecific | undefined
    const type = payload?.type
    let code = payload?.code
    if (
      (type === 'JSExpression' ||
        type === 'Expression' ||
        type === 'Mustache') &&
      typeof code === 'string' &&
      (code = code.trim()) !== '' && // 跳过空字符串，在某种情况下空字符串是缺省的意思，不能被当作常量处理
      !code.includes('{{') // 跳过包含 {{ 的字符串，说明是带有动态表达式的字符串
    ) {
      let result
      if (payload?.mode === 'string') {
        result = code
      } else if (code) {
        if (constantMap.has(code)) {
          result = constantMap.get(code)
        } else {
          try {
            result = new Function(`return (${json5Parse(code)})`)()
          } catch {
            result = code
          }
          if (constantMap.size >= MAX_CACHE_SIZE) {
            constantMap.delete(constantMap.keys().next().value)
          }
          constantMap.set(code, result)
        }
        if (result != null && typeof result === 'object') {
          try {
            result = structuredClone(result)
          } catch {
            result = clone(result)
          }
        }
      }
      if (ctx?.node?.getTypedSchema?.(ctx.path)) {
        result = ctx.node.transformPropertyIn(ctx.path, result)
      }
      return result
    }
  } catch {}
  return next(ctx)
}
